import React from "react";
import "./Placement.css";
import placementImg1 from "../../Images/placementImg1.jpg";
import placementImg2 from "../../Images/placementImg2.png";
import placementIcon1 from "../../Images/Icons/placementIcon1.png";
import placementImg3 from "../../Images/placementImg3.webp";
import placementImg4 from "../../Images/placementImg4.png";
import placementImg5 from "../../Images/placementImg5.jpg";

const Placement = () => {
  return (
    <div className="placementSection">
      <div className="placementHero">
        <img src={placementImg1} alt="placementImg1" />
        <div className="placementHeroCover">
          <div className="placementHeroText">
            <h1>Explore Career Paths That Lead to Real Opportunities</h1>
            <p>
              Search placements by category to uncover internships, entry-level
              roles, and industry-specific opportunities. Your next step starts
              here.
            </p>
          </div>
        </div>
      </div>

      <div className="placementSupport">
        <h2>Job Support</h2>
        <div className="supportSection">
          <div className="supportText">
            <h2>End-to-End Job Support That Puts Students First</h2>
            <p>
              Career Restorer offers comprehensive job support tailored to
              student needs. We guide you through resume building, interview
              preparation, and skill alignment—ensuring you're ready for both IT
              and non-IT roles. Our listings are thoroughly vetted to protect
              against scams and misinformation, so you can apply with
              confidence. Whether you're seeking internships, fresher roles, or
              career transitions, our platform connects you with verified
              employers and equips you with actionable resources, mentorship,
              and placement training to help you succeed.
            </p>
          </div>
          <div className="supportImg">
            <img src={placementImg2} alt="placementImg2" />
          </div>
        </div>
        <div className="supportBlock">
          <div className="supportCards">
            <img src={placementIcon1} alt="placementIcon1" />
            <h3>Resume Building</h3>
            <p>ATS-friendly resumes crafted to highlight your strengths.</p>
          </div>
          <div className="supportCards">
            <img src={placementIcon1} alt="placementIcon1" />
            <h3>Mock Interviews</h3>
            <p>Practice with industry experts before the real thing.</p>
          </div>
          <div className="supportCards">
            <img src={placementIcon1} alt="placementIcon1" />
            <h3>Job Referrals</h3>
            <p>Access to our exclusive partner job network.</p>
          </div>
          <div className="supportCards">
            <img src={placementIcon1} alt="placementIcon1" />
            <h3>1:1 Mentorship</h3>
            <p>Personal guidance tailored to your career goals.</p>
          </div>
          <div className="supportCards">
            <img src={placementIcon1} alt="placementIcon1" />
            <h3>Interview Prep</h3>
            <p>HR + technical interview preparation sessions.</p>
          </div>
          <div className="supportCards">
            <img src={placementIcon1} alt="placementIcon1" />
            <h3>Ongoing Support</h3>
            <p>We continue to support you even after placement.</p>
          </div>
        </div>
        <div className="supportBlock2">
          <div className="supportBlockImg">
            <img src={placementImg3} alt="placementImg3" />
          </div>
          <div className="supportBlockText">
            <h3>
              Secure Your Future with Verified Placements and Real Support
            </h3>
            <p>
              Join a placement program built for students who want more than
              just job listings. At Career Restorer, we offer mentorship,
              scam-free opportunities, and personalized guidance to help you
              land roles that match your skills and aspirations. Start your
              journey with confidence—your career deserves it.
            </p>
          </div>
        </div>
      </div>
      <h2>Success Story</h2>
      <div className="placementBlock">
        <div className="placementImg">
          <img src={placementImg4} alt="placementImg4" />
        </div>
        <div className="placementText">
          <h3>Success Stories That Inspire Confidence and Action</h3>
          <p>
            Our placement program has helped hundreds of students transition
            from learning to earning. From first-generation graduates landing
            their dream roles to career switchers finding new purpose, each
            story reflects the power of guidance, verified opportunities, and
            skill-based support. These journeys aren’t just wins—they’re proof
            that with the right platform, success is within reach.
          </p>
        </div>
      </div>
      <div className="placementStory">
        
        <div className="storyBlock">
          <div className="storyCard">
            <div className="storyImg">
              <img src={placementImg5} alt="placementImg4" />
            </div>
            <div className="stroyText">
              <h3>Kumar R</h3>
              <h4>Full Stack Developer</h4>
              <h4>Infosys</h4>
              <p>
                The mock interviews and resume guidance boosted my confidence. I
                landed my dream role within 2 months.
              </p>
            </div>
          </div>
          <div className="storyCard">
            <div className="storyImg">
              <img src={placementImg5} alt="placementImg4" />
            </div>
            <div className="stroyText">
              <h3>Kumar R</h3>
              <h4>Full Stack Developer</h4>
              <h4>Infosys</h4>
              <p>
                The mock interviews and resume guidance boosted my confidence. I
                landed my dream role within 2 months.
              </p>
            </div>
          </div>
          <div className="storyCard">
            <div className="storyImg">
              <img src={placementImg5} alt="placementImg4" />
            </div>
            <div className="stroyText">
              <h3>Kumar R</h3>
              <h4>Full Stack Developer</h4>
              <h4>Infosys</h4>
              <p>
                The mock interviews and resume guidance boosted my confidence. I
                landed my dream role within 2 months.
              </p>
            </div>
          </div>
          <div className="storyCard">
            <div className="storyImg">
              <img src={placementImg5} alt="placementImg4" />
            </div>
            <div className="stroyText">
              <h3>Kumar R</h3>
              <h4>Full Stack Developer</h4>
              <h4>Infosys</h4>
              <p>
                The mock interviews and resume guidance boosted my confidence. I
                landed my dream role within 2 months.
              </p>
            </div>
          </div>
          <div className="storyCard">
            <div className="storyImg">
              <img src={placementImg5} alt="placementImg4" />
            </div>
            <div className="stroyText">
              <h3>Kumar R</h3>
              <h4>Full Stack Developer</h4>
              <h4>Infosys</h4>
              <p>
                The mock interviews and resume guidance boosted my confidence. I
                landed my dream role within 2 months.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Placement;
